import React from "react";
//#region redux
//#endregion
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DateRangeProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import Icon from "./icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const DateRange: React.FC<DateRangeProps> = (props) => {
  return props.start ? (
    <Grid container spacing={1} alignItems="center" wrap="nowrap" className={cssExports.dateRange}>
      <Grid item>{LocalizationHelperInstance.getFormattedDate(props.start)}</Grid>
      {props.end && (
        <>
          <Grid item>
            <Icon icon={props.separatorIcon ? props.separatorIcon : IconDefinitionConstants.WArrowSmallRight} />
          </Grid>
          <Grid item>{LocalizationHelperInstance.getFormattedDate(props.end)}</Grid>
        </>
      )}
    </Grid>
  ) : (
    <></>
  );
};

export default DateRange;
